import axios from 'axios';

import { DUPLICATE_REQUEST_CANCEL_REASON } from '../constants/duplicateRequestCancelReason';

export const isDuplicateRequestCancelError = (error: unknown): boolean => {
  if (!axios.isCancel(error)) {
    return false;
  }

  // axios leaves the aborted signal on the rejected request's config, so the
  // reason the aborter supplied travels with the error. Typed locally because
  // axios types the config signal as GenericAbortSignal, which has no `reason`.
  const { config } = error as { config?: { signal?: AbortSignal } };

  return config?.signal?.reason === DUPLICATE_REQUEST_CANCEL_REASON;
};
